<template>
  <div>
    <form v-if="form" @submit.native="submit">
      <div class="is-flex is-align-items-center is-justify-content-space-between" style="margin-bottom: 10px;">
        <a @click="generateOffers" class="button is-info">Generate Offers</a>
        <a @click="createPost" class="button is-info">Create Post</a>
        <a @click="jump" class="button is-info">Jump</a>
        <router-link :to="{ name: 'select-email-position-applicants', query: { position_id: position.id, company_id: position.company.resource_id } }"
                     class="button is-info">Email Applicants</router-link>
        <a @click="outsource" class="button is-info">Outsource</a>
      </div>
      <position-form-links :position_id="payload.data.id" :company_id="payload.data.company.resource_id" :position_status="position.status"></position-form-links>
      <div v-if="form" style="text-align: right; margin-top: 20px;" dir="rtl">
        <div>
          <p class="bold">title</p>
          <input
            v-model="form.data.position.fields.title.value"
            class="outlined full_width"
            placeholder="title"
          />
        </div>
        <div>
          <p class="bold">status</p>
          <select v-model="form.data.position.fields.status.value" dir="rtl">
            <option value="editing">editing</option>
            <option value="active">active</option>
            <option value="standby">standby</option>
            <option value="blocked">blocked</option>
            <option value="expired">expired</option>
            <option value="fullfiled">fullfiled</option>
            <option value="deleted">deleted</option>
            <option value="test">test</option>
          </select>
        </div>
        <div>
          <p class="bold">owner</p>
          <input
            v-model="form.data.position.fields.owner.value"
            class="outlined full_width"
            placeholder="owner"
          />
        </div>
        <div>
          <p class="bold">priority warning</p>
          <input
            v-model="form.data.position.fields.priority_warning.value"
            class="outlined full_width"
            placeholder="priority warning"
          />
        </div>
      </div>
      <div class="modal_footer">
        <a
          @click="submit()"
          :class="{ 'is-loading': is_loading }"
          class="button is-info"
          >Submit</a
        >
      </div>
    </form>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import PositionsHelper from '@/custom/classes/positions_helper.js'
import PositionFormLinks from '@/components/PositionFormLinks'
export default {
  props: ['payload'],
  name: 'admin-position-form',
  data () {
    return {
      positions_helper: new PositionsHelper(),
      is_loading: false,
      form: undefined,
      position: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getPosition({ id: this.payload.data.id }).then((response) => {
        this.position = response
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        position: {
          fields: {
            title: {
              value: form_data.title,
              has_error: false,
              validations: []
            },
            status: {
              value: form_data.status,
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            priority_warning: {
              value: form_data.priority_warning,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/positions/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.generateOffers()
        this.positions_helper.logToServer({
          old_status: this.position.status,
          new_status: this.form.data.position.fields.status.value,
          resource_id: this.payload.data.id,
          position_title: this.payload.data.title,
          company_id: this.payload.data.company.resource_id
        })
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    outsource () {
      this.create({
        designator: 'edit-outsource-position-form-modal',
        component_name: 'OutsourcePositionForm',
        env_position_id: this.payload.data.id,
        modal_title: 'Outsource - ' + this.form.data.position.fields.title.value
      })
    },
    createPost () {
      this.create({
        designator: 'create-position-post-form',
        component_name: 'CreatePositionPostForm',
        position_id: this.payload.data.id,
        modal_title: 'Create Position Post - ' + this.form.data.position.fields.title.value,
        is_center_modal: true,
        modal_width: 1700
      })
    },
    generateOffers () {
      let status = this.form.data.position.fields.status.value == undefined ? this.position.status : this.form.data.position.fields.status.value
      this.$network_utils.sendPositionUpdateEvent({
        company_id: this.payload.data.company.resource_id,
        position_id: this.payload.data.id,
        status: status
      }).then(() => {
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      })
    },
    jump () {
      this.$caller.request('put', '/positions/' + this.payload.data.id, 'admin_headers', {
        updated_at: new Date().toUTCString()
      }).then(() => {
        this.$utils.emit('show_toast', { text: 'הוקפץ בהצלחה' })
      })
    },
    ...mapMutations('modals', ['create', 'remove'])
  },
  components: {
    PositionFormLinks
  }
}
</script>
